import { h } from 'preact';

import privacy from '../../../data/legal/old-policy.md';

import { Markdown } from '../../components/Markdown';
import { Title } from '../../components/title';
import { Section, Grid } from '../../components/Grid';

const OldPrivacyPolicy = () => (
    <Section>
        <Grid center md={10}>
            <article>
                <Title
                    id="privacy-policy"
                    className="u-text-center u-txt-purple-100 dark:u-txt-purple-30"
                >
                    Privacy policy
                </Title>
                <Markdown content={privacy} className="s-markdown u-mb-12" />
            </article>
        </Grid>
    </Section>
);

export default OldPrivacyPolicy;
